module.exports = "/packs/media/images/logo-betterment-e6a038fa6317f25824f000edf3779f0f.png";